import React, { useEffect, useState } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Autocomplete, { highlightSubstring } from '@afosto/app-components-react/Autocomplete';
import findObjectInArray from '@afosto/utils/array/findObjectInArray';
import getAddressString from '@afosto/utils/getAddressString';
import { addresses as addressesApi } from '@afosto/contacts/api/Addresses';
import { fulfilment as fulfilmentApi } from '@afosto/fulfilment/api/Fulfilment';

const FulfilmentLocationSearch = ({ filterSuggestions, name, ...props }) => {
  const [locations, setLocations] = useState([]);
  const [isFetchingLocations, setIsFetchingLocations] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchLocations = async () => {
      setIsFetchingLocations(true);

      try {
        const response = await fulfilmentApi.listFulfilmentLocations();
        const { data = [] } = response;
        const addressPromises = data.map(location => addressesApi.viewAddress(location.address_id));
        const addressResponses = await Promise.allSettled(addressPromises).then(result =>
          result.filter(promise => promise.status === 'fulfilled'),
        );
        const addresses = addressResponses.reduce((acc, addressResponse) => {
          if (addressResponse?.value?.data) {
            return [...acc, addressResponse.value.data];
          }

          return acc;
        }, []);

        if (isMounted) {
          const formattedLocations = data.reduce(
            (acc, item) => [
              ...acc,
              {
                ...item,
                address: findObjectInArray(addresses, 'id', item.address_id),
                label: item.name,
                value: item.id,
              },
            ],
            [],
          );
          setLocations(formattedLocations);
        }
      } catch (err) {
        if (isMounted) {
          setLocations([]);
        }
      } finally {
        if (isMounted) {
          setIsFetchingLocations(false);
        }
      }
    };

    fetchLocations();

    return () => {
      isMounted = false;
    };
  }, []);

  const renderSuggestion = (option, { inputValue = '' } = {}) => (
    <ListItem component="div" dense disableGutters>
      <ListItemText
        primary={highlightSubstring(option.label, inputValue)}
        secondary={highlightSubstring(
          option?.address ? getAddressString(option.address) : '',
          inputValue,
        )}
      />
    </ListItem>
  );

  return (
    <Autocomplete
      {...props}
      name={name}
      options={locations}
      loading={isFetchingLocations}
      renderOption={renderSuggestion}
      autocomplete="off"
    />
  );
};

FulfilmentLocationSearch.propTypes = Autocomplete.propTypes;

FulfilmentLocationSearch.defaultProps = Autocomplete.defaultProps;

export default FulfilmentLocationSearch;
